import core, { API } from '@gin-betting/core';
import { reduce } from 'lodash';

const {
    hooks: { useDeepMemo },
} = core;

interface Input {
    tournaments: API.CategorizerItem[];
}

interface Output {
    tournamentIds: string[];
    totalCount: number;
}

export default function useCountryInfo({ tournaments }: Input): Output {
    const { tournamentIds, totalCount } = useDeepMemo(
        () =>
            reduce(
                tournaments,
                (
                    acc: {
                        tournamentIds: string[];
                        totalCount: number;
                    },
                    { value, count }
                ) => {
                    acc.tournamentIds.push(value);
                    acc.totalCount += count;

                    return acc;
                },
                {
                    tournamentIds: [],
                    totalCount: 0,
                }
            ),
        [tournaments]
    );

    return {
        tournamentIds,
        totalCount,
    };
}
